// used to get all nearby groups and users
// used for allowing more easy joining of groups

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  nearbyGroups: [],
  nearbyUsers: [],
};

const nearbySlice = createSlice({
  name: 'nearby',
  initialState,
  reducers: {
    updateNearbyGroups(state, {payload: nearbyGroups}) {
      state.nearbyGroups = nearbyGroups;
    },
    updateNearbyUsers(state, {payload: nearbyUsers}) {
      state.nearbyUsers = nearbyUsers;
    },
  },
});

export const {updateNearbyGroups, updateNearbyUsers} = nearbySlice.actions;
export default nearbySlice.reducer;
